<template>
  <div>
    <h2>Responsive 响应式布局</h2>
    <p>组件 vue-form-line 内的元素可以使用任意组件，这里使用的是element组件示例。</p>
    <demo>
      <vue-form :model="form" :rowledge="24">
        <vue-form-line :cols="[{ label: '商品名称' },{ label: '商品类型' }]">
          <el-input v-model="form.name" placeholder="请输入商品名称" />
          <el-input v-model="form.type" placeholder="请输入商品类型" />
        </vue-form-line>
        <vue-form-line label="尺寸" :cols="[{ span: 8 },{ span: 8 }, { span: 8 }]" :span="12">
          <el-input v-model="form.long" placeholder="请输入长度" />
          <el-input v-model="form.width" placeholder="请输入宽度" />
          <el-input v-model="form.height" placeholder="请输入高度" />
        </vue-form-line>
        <vue-form-line :cols="[{ label: '重量' }]" :span="12">
          <el-input v-model="form.weight" placeholder="请输入长度">
            <template slot="append">kg</template>
          </el-input>
        </vue-form-line>
      </vue-form>
      <div slot="description">
        <p>说明</p>
      </div>
      <div slot="meta">
        <vue-markdown v-highlight :source="content"></vue-markdown>
      </div>
    </demo>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: `
    <template>
      <vue-form :model="form" :rowledge="24">
        <vue-form-line :cols="[{ label: '商品名称' },{ label: '商品类型' }]">
          <el-input v-model="form.name" placeholder="请输入商品名称" />
          <el-input v-model="form.type" placeholder="请输入商品类型" />
        </vue-form-line>
        <vue-form-line label="尺寸" :span="12">
          <el-input v-model="form.long" placeholder="请输入长度" />
          <el-input v-model="form.width" placeholder="请输入宽度" />
          <el-input v-model="form.height" placeholder="请输入高度" />
        </vue-form-line>
        <vue-form-line :cols="[{ label: '重量', span: '14' }]" :span="12">
          <el-input v-model="form.weight" placeholder="请输入长度" />
          <el-button>search</el-button>
        </vue-form-line>
      </vue-form>
    <\/template>

    <script>
      export default {
        data() {
          return {
            form: {
              name: "",
              type: "",
              long: "",
              width: "",
              height: ""
            }
          }
        }
      }
    <\/script>
      `,
      form: {
        name: "",
        type: "",
        long: "",
        width: "",
        height: ""
      }
    };
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/layou/responsive.vue